import { registerIcons } from "@fluentui/style-utilities";
import { fontBackColor, fontIcon } from "./style.scss";

import classNames from "owa-classnames";

export default "BackColorPickerIcon";

registerIcons({
    icons: {
        BackColorPickerIcon: <span className={classNames(fontBackColor, fontIcon)}></span>,
    },
});
